<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-layout row wrap class="custom-mb">
        
            <v-dialog v-model="showFPModal" persistent max-width="290">
                <v-card>
                    <v-toolbar color="orange" dark small>
                        <v-toolbar-title>Reset Password</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn dark icon @click="showFPModal=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        Are you sure you want to reset password of this user?
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="dark" small @click="showFPModal=false">
                            No
                        </v-btn>
                        <v-btn color="orange " class="white-text" small @click="forgotPassword">
                            Yes
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- user detail modal start -->

            <!-- role detail modal start -->
            <v-dialog v-model="showRoleDetail" max-width="40%" scrollable>
                <v-card>
                    <v-toolbar dark color="orange">
                        <v-toolbar-title>Associated User Roles</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="showRoleDetail=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <span>Below is the list of Roles "User Name" have permissions for.</span>
                        <div v-if="roleDetails && Object.keys(roleDetails).length">
                            <v-divider></v-divider>
                            <v-chip :key="item.id" v-for="item in roleDetails.userRoles">{{item.Role.name}}</v-chip>
                            <v-divider></v-divider>
                            <div class="text-xs-center">
                                <v-btn color="orange darken- white--text" @click="showRoleDetail=false">OK</v-btn>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <!-- role detail modal end -->

            <!-- user detail modal start -->
            <v-dialog v-model="showUserDetail" max-width="60%" scrollable>
                <v-card>
                    <v-toolbar dark color="orange">
                        <v-toolbar-title>User Profile Details</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="showUserDetail=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div v-if="userDetails && Object.keys(userDetails).length">
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">Email</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">{{userDetails.email}}</div>
                                </div>
                            </div>

                            

                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">Name</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">{{userDetails.full_name}}</div>
                                </div>
                            </div>
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">User Name</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">{{userDetails.discourse_user_name}}</div>
                                </div>
                            </div>
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">Personal/Cell Number</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">
                                        <a
                        class="link-text"
                        target="_blank"
                        :href="'tel:' + userDetails.phone_1"
                      >{{userDetails.phone_1 | phone}}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">Posting Contact Number</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">
                                        <a
                        class="link-text"
                        target="_blank"
                        :href="'tel:' + userDetails.phone_2"
                      >{{userDetails.phone_2 | phone}}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">Address</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">{{userDetails.address}}</div>
                                </div>
                            </div>
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">Secondary Address</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">{{userDetails.address2 != '' ? userDetails.address2 : notProvidedStr}}</div>
                                </div>
                            </div>
                            
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">Company Name</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">{{userDetails.company_name != '' ? userDetails.company_name : notProvidedStr}}</div>
                                </div>
                            </div>
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">MC Number</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">
                                        <a
                        v-if="userDetails.mc_number && userDetails.mc_number.length > 0"
                        class="link-text"
                        :href="mcNumberLink+userDetails.mc_number"
                        target="_blank"
                      >{{userDetails.mc_number}}</a>
                                        {{(userDetails.mc_number && userDetails.mc_number.length > 0)?'':notProvidedStr}}
                                    </div>
                                </div>
                            </div>
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">DOT Number</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">{{userDetails.dot_number != '' ? userDetails.dot_number : notProvidedStr}}</div>
                                </div>
                            </div>
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">LOADMAX Forum Username</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">{{userDetails.discourse_user_name}}</div>
                                </div>
                            </div>
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">User Status</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">{{userDetails.status}}</div>
                                </div>
                            </div>

                            <br>
                            <span>Associated User Roles:</span>
                            <v-divider></v-divider>
                            <v-chip :key="item.id" v-for="item in userDetails.userRoles">{{item.Role.name}}</v-chip>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <!-- user detail modal end -->
            <!--START:USER DELETE MODAL-->
            <v-dialog v-model="showDeleteModal" persistent max-width="290">
                <v-card>
                    <v-toolbar color="orange" dark small>
                        <v-toolbar-title>Delete User</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn dark icon @click="showDeleteModal=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        Are you sure you want to delete this user?
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="dark" small @click="showDeleteModal=false">
                            No
                        </v-btn>
                        <v-btn color="orange " class="white-text" small @click="deleteUser">
                            Yes
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--STOP:USER DELETE MODAL-->
            <v-flex lg12>
                <v-card>
                    <v-toolbar card color="white">
                        <v-toolbar-title>
                            <h3>Users</h3>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>

                        <router-link class="link-btn" v-if="permissionName=='all'" :to="{name: 'AddUser'}">
                            <v-icon color="black">add</v-icon>
                        </router-link>
                    </v-toolbar>
                    <breadcrumbs :items="breadcrumbs" divider=">"></breadcrumbs>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        <v-spacer></v-spacer>
                        <v-layout row wrap>
                            <v-flex lg6>
                                <v-text-field solo append-outer-icon="search" class="customTxt" placeholder="Search" v-model="search"></v-text-field>
                            </v-flex>
                            <v-flex lg3>
                                <v-select class="custom_dropdown" v-validate="'required'" v-model="userRoles" :items="user_roles_arr" data-vv-as="User Roles" item-text="name" item-value="value" label="User Roles" @change="onFilterSearch"></v-select>
                            </v-flex>
                            <v-flex lg3>
                                <v-select class="custom_dropdown" v-validate="'required'" v-model="userStatus" :items="user_status_arr" data-vv-as="User Status" item-text="name" item-value="value" label="User Status" @change="onFilterSearch"></v-select>
                            </v-flex>                            
                        </v-layout>
                        <v-spacer></v-spacer>

                        <v-data-table :disable-initial-sort="true" :headers="headers" :search="search" :items="users" :rows-per-page-items="[10,25,50,{text:'All','value':-1}]" class="elevation-1 customeUserListTbl" item-key="name">
                            <template slot="items" slot-scope="props">
                                <td>
                                    <v-tooltip top>
                                        <div slot="activator" class="td-pos-rel">
                                            <template v-if="props.item.restrictedFlag">
                                                <v-icon class="icon-usr-pos-abs" size="15" color="red">fas fa-exclamation-triangle</v-icon>
                                            </template>
                                        </div>
                                        <span>User info contain some restricted words!</span>
                                    </v-tooltip>
                                    {{ props.item.full_name }}
                                </td>
                                <td>{{ props.item.email }}</td>
                                <td>{{ props.item.pin_no }}</td>
                                <td style="text-transform: capitalize;">{{props.item.status}}</td>
                                <td>
                                    <v-list-tile flat small color="primary" class="userroleslength" @click="showRoleDetail=true; roleDetails=props.item;">
                                        <span v-if="props.item.roles_arr.includes(config.userRolesBrokerDefaultSlug) && props.item.roles_arr.includes(config.userRolesTruckerDefaultSlug)">{{config.userRolesBrokerDefaultSlug}}, {{config.userRolesTruckerDefaultSlug}}</span>
                                        <span v-if="props.item.roles_arr.includes(config.userRolesBrokerDefaultSlug) && !props.item.roles_arr.includes(config.userRolesTruckerDefaultSlug)">{{config.userRolesBrokerDefaultSlug}}</span>
                                        <span v-if="!props.item.roles_arr.includes(config.userRolesBrokerDefaultSlug) && props.item.roles_arr.includes(config.userRolesTruckerDefaultSlug)">{{config.userRolesTruckerDefaultSlug}}</span>
                                        <span v-if="!props.item.roles_arr.includes(config.userRolesBrokerDefaultSlug) && !props.item.roles_arr.includes(config.userRolesTruckerDefaultSlug)">{{props.item.roles_arr.slice(0, 2).join()}}</span>
                                    </v-list-tile>
                                </td>
                                <td>{{ props.item.create_date }}</td>
                                <td>{{ props.item.update_date }}</td>
                                <td width="170px">
                                    <v-tooltip top>
                                        <v-btn slot="activator" class="remove-border" depressed outline icon fab dark color="orange" small @click="showUserDetail=true; userDetails=props.item;">
                                            <v-icon>fa-eye</v-icon>
                                        </v-btn>
                                        <span>View</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <v-btn slot="activator" class="remove-border" v-if="permissionName=='all' && companyId != props.item.uuid" :to="{name:'Edituser', params:{id:props.item.uuid}}" depressed outline icon fab dark color="orange" small>
                                            <v-icon>fa-edit</v-icon>
                                        </v-btn>
                                        <span>Edit</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                      <v-btn slot="activator" class="remove-border" v-if="resetPasswordPermission=='all'" @click="showFPModal=true; userId=props.item.uuid" depressed outline icon fab dark color="orange" small>
                                          <v-icon>fa-key</v-icon>
                                      </v-btn>
                                      <span>Reset Password</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                      <v-btn slot="activator" class="remove-border" v-if="props.item.status == 'active' && permissionName=='all' && !mirrorAccountIcon" depressed outline icon fab dark color="orange" small @click="mirrorUser(props.item.uuid);">
                                          <v-icon>fa-user</v-icon>
                                      </v-btn>
                                      <span>Mirror Account</span>
                                    </v-tooltip>
                                    <v-tooltip top v-if="Issuperadmin">
                                        <v-btn slot="activator" class="remove-border" depressed outline icon fab dark color="red" small @click="showDeleteModal=true; deleteUserId=props.item.uuid">
                                            <v-icon>fa-trash</v-icon>
                                        </v-btn>
                                        <span>Delete</span>
                                    </v-tooltip>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import {
    mapActions
} from "vuex";
import services from "../../services/HttpService";
import breadcrumbs from "../widgets/Breadcrumb";
import VWidget from "@/components/VWidget";
import moment from "moment";
import config from "../../config";
import utils from "../../util/";
import GoogleAds from "@/pages/widgets/GoogleAds";
import {
    constants
} from "fs";
export default {
    data() {
        return {
            config: config,
            mirrorAccountIcon: false,
            notProvidedStr: config.notProvidedStr,
            mcNumberLink: config.mcNumberLocation,
            showRoleDetail: false,
            showUserDetail: false,
            showDeleteModal: false,
            deleteUserId: null,
            roleDetails: null,
            userDetails: null,
            permissionName: null,
            status: null,
            companyId: null,
            showFPModal: false,
            userId: null,
            resetPasswordPermission: null,
            headers: [
                
                {
                    text: "Name",
                    value: "full_name"
                },
                {
                    text: "Email",
                    value: "email"
                },
                {
                    text: "Pin",
                    value: "pin_no"
                },
                {
                    text: "Status",
                    value: "status"
                },
                {
                    text: "Roles",
                    value: ""
                },
                {
                    text: "Created Date",
                    value: "create_date"
                },
                {
                    text: "Updated Date",
                    value: "update_date"
                },
                {
                    text: "Actions",
                    value: "",
                    sortable: false
                }
            ],
            users: [],
            usersFinal: [],
            userStatus: "",
            userRoles: "",
            user_status_arr: [{
                    name: "Select Status",
                    value: ""
                },
                {
                    name: "Active",
                    value: "active"
                },
                {
                    name: "Pending",
                    value: "pending"
                },
                {
                    name: "Disabled",
                    value: "disabled"
                },
                {
                    name: "Cancelled",
                    value: "cancelled"
                },
                {
                    name: "Postonce",
                    value: "postonce"
                },
                {
                    name: "Posteverywhere",
                    value: "posteverywhere"
                }
            ],
            user_roles_arr: [{
                    name: "Select roles",
                    value: ""
                },
                {
                    name: "Broker",
                    value: config.userRolesBrokerDefaultSlug
                },
                {
                    name: "Trucker",
                    value: config.userRolesTruckerDefaultSlug
                },
                {
                    name: "Both",
                    value: "both"
                }
            ],
            search: "",
            breadcrumbs: [{
                    name: "Dashboard",
                    to: "/dashboard",
                    disabled: false
                },
                {
                    name: "Reporting",
                    to: "/comingsoon",
                    disabled: false
                },
                {
                    name: "Users",
                    disabled: true
                }
            ],
            Issuperadmin:false
        };
    },
    mounted() {
        this.permissionName = this.$store.state.user ? this.$store.state.user.permissions.users : null;
        this.companyId = this.$store.state.user ? this.$store.state.user.company_id : null;
        this.resetPasswordPermission = this.$store.state.user ? this.$store.state.user.permissions.reset_password : null;
        this.mirrorAccountIcon = this.$store.state.user && typeof this.$store.state.user.back_user_uuid != 'undefined' && this.$store.state.user.back_user_uuid != '';
    },
    components: {
        breadcrumbs,
        VWidget,
        GoogleAds
    },
    async created() {
        const self = this,
            wApp = window.getApp;
        self.utils = utils;
        await self.checkSuperadmin();
        wApp.$emit("showLoader", {
            show: true
        });
        let restrictedWord = "anal|anus|arse|ass|fuck|ass hole|assfucker|asshole|assshole|bastard|bitch|black cock|"
        restrictedWord += "bloodyhell|boong|cock|cockfucker|cocksuck|cocksucker|coonnass|crap|cunt|cyberfuck|damn|dar\|"
        restrictedWord += "dick|dirty|douche|dummy|erect|erection|erotic|escort|fag|faggot|fuck|Fuck off|fuck you|"
        restrictedWord += "fuckass|fuckhole|god damn|hard core|hardcore|h omoerotic|hore|lesbian|lesbians|"
        restrictedWord += "mother fucker|motherfuck|motherfucker|orgasm|penis|penis fucker|piss|piss off|porn|"
        restrictedWord += "porno|pornography|pussy|retard|sadist|sex|sexy|shit|slut|son of a bitch|suck|tits|"
        restrictedWord += "viagra|whore|xxx|mic|wop|jap|chink|nip. squint kike|chink|cracker|gook|honkey|negro|nigger|"
        restrictedWord += "sandnigger|spic|whitey|wetback|wigger tar baby|spear chucker|slope|hooknose|jiggaboo|"
        restrictedWord += "jigga|kraut|cracker|niggers|spics|pakis|chinks|nips|krauts|frogs|wops|wogs|paddies|"
        restrictedWord += "limeys|polaks|kikes|dune coons|gooks";
        let regex = new RegExp("\\b(?:" + restrictedWord + ")\\b", "gi");

        services
            .get("users/list", {
                Authorization: "Bearer " + this.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                this.users = res.data.usersListing.map(u => {
                    u.create_date = moment(u.create_date).format("MMM DD, YYYY");
                    u.update_date = moment(u.update_date).format("MMM DD, YYYY");
                    u.full_name = u.first_name + " " + u.last_name;
                    u.restrictedFlag = false;
                    if(u.full_name.match(regex) || u.discourse_user_name.match(regex) || u.company_name.match(regex) || u.company_alternate_address.match(regex)){
                        u.restrictedFlag = true;
                    }
                    u.roles_arr = [];
                    u.userRoles.map(function(u1){
                        if(u1.Role.slug != ''){
                            u.roles_arr.push(u1.Role.slug);
                        } else {
                            u.roles_arr.push(u1.Role.name);
                        }
                    });
                    return u;
                });
                this.usersFinal = this.users;
            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, "red");
            });
    },
    methods: {
        ...mapActions(["login"]),
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        async checkSuperadmin(){
          const self = this;
          self.Issuperadmin = await self.$store.state.user.Issuperadmin;
        },
        deleteUser() {
            const self = this,
                wApp = window.getApp;
            self.showDeleteModal = false;
            wApp.$emit("showLoader", {
                show: true
            });
            services
                .delete(
                    "users/delete", {
                        uuid: self.deleteUserId
                    }, {
                        Authorization: "Bearer:" + this.$store.state.user.token
                    }
                )
                .then(res => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    if (res.status === 200) {
                        self._showToast(res.data.message);
                        self.users = this.users.filter(function (obj) {
                            return obj.uuid !== self.deleteUserId;
                        });
                        self.deleteUserId = null;    
                    }else{
                        self._showToast(res.data.message,config.errMsgColorStr);
                    }
                })
                .catch(err => {
                    self.deleteUserId = null;
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, config.errMsgColorStr);
                });
        },
        onUserStatusChange(value) {
            if(this.userRoles != ''){

            } else if (value != "") {
                this.users = this.usersFinal.filter(function (obj) {
                    return obj.status == value;
                });
            } else {
                this.users = this.usersFinal;
            }
        },
        onFilterSearch() {
            const self = this;
            if(self.userRoles == '' && self.userStatus == ''){
                self.users = self.usersFinal;                
            } else {
                self.users = self.usersFinal.filter(function (obj) {

                    if(self.userRoles != '' && self.userRoles == 'both'){
                        if(obj.roles_arr.includes(config.userRolesBrokerDefaultSlug) && obj.roles_arr.includes(config.userRolesTruckerDefaultSlug) && self.userStatus != '' && (obj.status == self.userStatus)){
                            return true;

                        } if(obj.roles_arr.includes(config.userRolesBrokerDefaultSlug) && obj.roles_arr.includes(config.userRolesTruckerDefaultSlug) && self.userStatus == ''){
                            return true;

                        } else {
                            return false;
                        }
                    } else if(self.userRoles != '') {

                        if(obj.roles_arr.includes(self.userRoles) && self.userStatus != '' && obj.status == self.userStatus){
                            return true;

                        } else if(obj.roles_arr.includes(self.userRoles) && self.userStatus == '' ){
                            return true;

                        } else {
                            return false;
                        }
                    } else {
                        if(self.userStatus != '' && obj.status == self.userStatus){
                            return true;

                        } else {
                            return false;
                        }
                    }

                    // return tmpData.length;
                });
            }
        },
        // onUserRolesChange(value) {
        //     const self = this;
        //     console.log(self.userStatus)
        //     if (value != "") {
        //         self.users = self.usersFinal.filter(function (obj) {
        //             let tmpData = obj.userRoles.filter(function (obj1){
        //                 if(obj1.Role.slug != ''){

        //                     if(value == 'both'){
        //                         if(obj1.Role.slug == config.userRolesBrokerDefaultSlug || obj1.Role.slug == config.userRolesTruckerDefaultSlug){
        //                             return true;
        //                         }
        //                     } else {
        //                         if(obj1.Role.slug == value){
        //                             return true;
        //                         }
        //                     }
        //                 } else {
        //                     return false;
        //                 }                                                
        //             });
        //             return tmpData.length;
        //         });
        //     } else if(self.userStatus != ''){
        //         self.onUserStatusChange(self.userStatus);
        //     } else {
        //         self.users = self.usersFinal;
        //     }
        // },
        forgotPassword(){
            const self = this,
            wApp = window.getApp;
            self.showFPModal = false;
            wApp.$emit("showLoader", {
                show: true
            });
            services.post("users/resetPasswordSendLink", {
                    uuid: self.userId
                }, {
                    "Authorization": "Bearer:" + this.$store.state.user.token
                })
                .then(res => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(res.data.message);
                    self.userId = null;
                })
                .catch(err => {
                    self.userId = null;
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, "red");
                });
        },
        
        mirrorUser(switch_user_uuid) {
            const self = this;
            utils.mirrorUser(switch_user_uuid, self.$store.state.user.uuid,self, function (userData){
                if(userData.user_profile_pic==""){
                    userData.user_profile_pic = config.defaultProfilePicPath;
                }
                self.login({
                    user: userData
                });
                window.location.href = '/dashboard';
            });
            
        }
    }
}
</script>

<style>
.v-btn.remove-border {
    border: none !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/users/List.vue